<template>
  <div class="driverTaskDetail">
    <el-drawer
      size="1000px"
      :data="visible"
      :visible.sync="visible"
      title="运费付款单"
      v-el-drawer-drag-width
      :before-close="cancelModal"
    >
      <!-- <basic-container> -->
    
      <div ref="print" class="detail">
        <div class="header">
          <div class="logo">
            <img src="@/static/zflogo.png" alt="" />
            <!-- <div class="logo-txt">
              捷运途
            </div> -->
          </div>
          <span style="border-bottom: 1px solid #313133;">
            <span v-if="tableData && tableData.length > 0">{{
              tableData[0].companyName
            }}</span></span
          >
          <span style="margin-left: 10px">运费付款单</span>
        </div>
        <!-- :summary-method="summaryMethod" -->
        <avue-crud
          ref="crud"
          style="width: 100%; font-size: 28px"
          :data="tableData"
          :table-loading="tableLoading"
          :option="tableOption"
          v-model="form"
          @on-load="getPage"
        >
        </avue-crud>
      </div>
      <div class="footer">
        <!-- <div class="left"> -->
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="tableData.length == 0"
            @click="exOut"
            class="custom-btn"
          >
            导出</el-button
          >
          <el-button
            type="primary"
            plain
            :loading="btnLoading"
            class="custom-btn"
            size="small"
            @click="printPDF"
          >
            下载PDF打印</el-button
          >
        <!-- </div> -->
        <!-- <div class="right">
          <el-button size="small" @click="cancelModal"> 取消</el-button>
          <el-button type="primary" size="small" @click="cancelModal">
            确定</el-button
          >
        </div> -->
      </div>
      <!-- </basic-container> -->
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  downloadFreightPaymentPdf,
  getPayeeGroupByPaymentIdListNew,
} from "@/api/chain/companyauthrecharge";
import { print } from "@/util/util.js";
import { expotOut } from "@/util/down.js";

export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    payeeName: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      form: {},
      tableData: [],
      paramsSearch: {},
      tableLoading: false,
      tableOption: {
        dialogDrag: false,
        border: true,
        indexLabel: "序号",
        stripe: false,
        align: "center",
        searchShow: false,
        labelWidth: 150,
        excelBtn: false,
        printBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        index: false,
        menu: false,
        showSummary: true,
        sumtext: "合计",
        refreshBtn: false,
        sumColumnList: [
          {
            label: "",
            name: "waybillCnt",
            type: "sum",
          },
          {
            label: "",
            name: "amount",
            type: "sum",
          },
          {
            name: "bankPaySuccessAmount",
            type: "sum",
          },
          {
            name: "bankPayProcessingAmount",
            type: "sum",
          },
          {
            name: "bankNoPayAmount",
            type: "sum",
          },
        ],
        column: [
          {
            label: "项目",
            prop: "projectInfoName",
            overHidden: true,
          },
          {
            label: "最近支付时间",
            prop: "payTimes",
            overHidden: true,
          },
          {
            label: "支付单号",
            prop: "paymentNo",
            overHidden: true,
          },
          {
            label: "收款人/车队",
            prop: "payeeName",
            overHidden: true,
          },
          {
            label: "收款卡号",
            prop: "bindingBankNo",
            overHidden: true,
          },
          {
            label: "收款银行",
            prop: "bindingBankName",
            overHidden: true,
          },
          {
            label: "手机号",
            prop: "payeeMobile",
            overHidden: true,
          },
          {
            label: "结算运单数量",
            prop: "waybillCnt",
            overHidden: true,
          },
          {
            label: "收款金额(合计金额)",
            prop: "amount",
            overHidden: true,
            width:150
          },
          {
            label: "已付金额",
            prop: "bankPaySuccessAmount",
            overHidden: true,
          },
          {
            label: "处理中金额",
            prop: "bankPayProcessingAmount",
            overHidden: true,
          },
          {
            label: "未付金额",
            prop: "bankNoPayAmount",
            overHidden: true,
          },
        ],
      },
      btnLoading: false,
    };
  },
  created() {},
  mounted: function () {},
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },
    getPage(page, params = {}) {
      this.tableLoading = true;
      let data = this.selectList.map((item) => {
        return item.id;
      });
      getPayeeGroupByPaymentIdListNew({
        paymentIdList: data,
        payeeName: this.payeeName,
      })
        .then((response) => {
          this.tableData = response.data.data;
          // if(this.tableData&&this.tableData.length>0){
          //   this.tableData.push(
          //     {
          //       projectInfoName:'合计',
          //     }
          //   )
          // }
          // this.page.total = response.data.data.total
          // this.page.currentPage = page.currentPage
          // this.page.pageSize = page.pageSize
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    summaryMethod({ columns, data }) {
      const sums = [];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          // console.log(column);
          let prop = column.property;
          if (["waybillCnt", "amount", "payAmount"].includes(prop)) {
            let values = this.tableData.map((item) => Number(item[prop] || 0));
            let all =
              values.length !== 0
                ? (sums[index] = values.reduce((a, b) => {
                    return a + b;
                  }))
                : 0;
            // if(prop=='sum'){
            sums[index] = all;
            // }else if(prop=='avg'){
            //   sums[index]=all/values.length || 0
            // }else if(prop=='count'){
            //   sums[index]=values.length
            // }
          } else {
            sums[index] = index == 6 ? "合计" : "";
          }
        });
      }
      return sums;
    },
    exOut() {
      let data = this.selectList.map((item) => {
        return item.id;
      });
      let url = "/chain/companypayment/exportPaymentApplyExcel";
      // params.id = this.info.id
      expotOut(
        { paymentIdList: data, payeeName: this.payeeName },
        url,
        "付款单"
      );
    },
    printPDF() {
      this.btnLoading = true;
      let data = this.selectList.map((item) => {
        return item.id;
      });
      downloadFreightPaymentPdf({ paymentIdList: data })
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "运费付款单.pdf"; //
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.avue-crud .cell {
  font-family: "Microsoft YaHei" !important;
  font-size: calc(12px / 0.7) !important;
}
/deep/ .el-drawer__header {
  margin-bottom: 0px;
  padding-bottom: 20px;
}
/deep/ .avue-crud__menu {
  display: none;
}
/deep/ .el-table {
  border-bottom: 0.5px solid #edeff0;
  border-right: 0.5px solid #edeff0;
  tr {
    .el-table__cell {
      border-left: 0.5px solid #edeff0;
      // border-top: .5px solid #edeff0;
    }
    border-right: 0.5px solid #edeff0;
  }
}
.detail {
  margin: 32px;
  /* 样式可以根据需要进行调整 */
  transform: scale(0.7); /* 缩小到80% */
  transform-origin: 0 0;
  width: 134.8% !important; /* 补偿缩放后的宽度 */
  height: 146% !important;
  // border: 1px solid #EDEFF0;
  // border-bottom: none;
  .header {
    position: relative;
    text-align: center;
    padding-bottom: 20px;
    padding-top: 20px;
    border: 1px solid #edeff0;
    border-bottom: none;
    span {
      font-weight: 400;
      font-size: 20px;
      color: #313133;
      &:first-child {
        font-weight: 500;
        font-size: 20px;
        color: #313133;
      }
    }
    .logo {
      position: absolute;
      left: 20px;
      top: 20px;
      img {
        width: 78px;
        height: 28px;
      }
    }
  }
}
/deep/.avue-crud__pagination {
  display: none;
}
/deep/.el-table__header th.is-leaf {
  background: #f5f8fa !important;
  border: 0.5px solid #edeff0 !important;
}
/deep/.el-table--border,
.el-table--group {
  border: none;
  &:after {
    width: 0;
  }
}
/deep/.el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  background: #fff;
}
.footer {
  padding: 16px 24px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  border-top: 1px solid #ededf0;
}
/deep/.el-drawer__header {
  border-bottom: 1px solid #ededf0 !important;
}
.custom-btn {
  background: #fff !important;
  &:hover {
    color: #35b1ff !important;
  }
}
</style>